import { useAuth0 } from "@auth0/auth0-react";
import { useAccessToken } from "../queries";

export function AuthenticatedOnly({ children }: React.PropsWithChildren<{}>) {
  const { isAuthenticated } = useAuth0();
  const token = useAccessToken();
  return isAuthenticated && token ? children : null;
}
